(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inkdeks-core-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inkdeks-feature-tabs')) {
    const inkdeksActiveTabs = new Map();
    customElements.define('inkdeks-feature-tabs', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.onBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const panel = event.target.closest('[data-panel]');
          if (panel) this.activate(panel.dataset.panel, false);
          const engine = event.target.closest('[data-engine-id]');
          if (engine) {
            const scroll = this.querySelector('[data-rack-scroll]');
            if (scroll) scroll.scrollTo({ left: engine.offsetLeft - (scroll.clientWidth - engine.clientWidth) / 2, behavior: 'auto' });
            this.openEngine(engine);
          }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.onModalClose = () => {
          this.currentEngine = null;
          this.querySelectorAll('[data-engine-rack] [data-engine-trigger]').forEach((button) => {
            button.setAttribute('aria-pressed', 'false');
            button.setAttribute('aria-expanded', 'false');
          });
        };
        this.querySelector('[data-engine-modal]')?.addEventListener('close', this.onModalClose);
        const remembered = inkdeksActiveTabs.get(this.dataset.sectionId);
        if (remembered) this.activate(remembered, false, false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        const modal = this.querySelector('[data-engine-modal]');
        modal?.removeEventListener('close', this.onModalClose);
        if (modal?.open) modal.close();
        clearTimeout(this.effectTimer);
      }

      onClick(event) {
        const garment = event.target.closest('[data-engine-trigger]');
        if (garment && this.contains(garment)) {
          const item = garment.closest('[data-engine-id]');
          this.openEngine(item);
          return;
        }
        const closeButton = event.target.closest('[data-engine-close]');
        if (closeButton && this.contains(closeButton)) {
          this.querySelector('[data-engine-modal]')?.close();
          return;
        }
        const stepButton = event.target.closest('[data-engine-step]');
        if (stepButton && this.contains(stepButton)) {
          this.stepEngine(Number(stepButton.dataset.engineStep));
          return;
        }
        const tab = event.target.closest('[data-tab]');
        if (tab && this.contains(tab)) this.activate(tab.dataset.tab, false, true);
      }

      stepEngine(direction) {
        const items = [...this.querySelectorAll('[data-engine-rack] [data-engine-id]')];
        const current = items.indexOf(this.currentEngine);
        if (!items.length || current < 0 || !Number.isFinite(direction)) return;
        const next = items[(current + direction + items.length) % items.length];
        this.updateEngine(next, true);
      }

      openEngine(item) {
        const modal = this.querySelector('[data-engine-modal]');
        if (!modal || !item) return;
        this.updateEngine(item, false);
        if (!modal.open) modal.showModal();
        modal.focus({ preventScroll: true });
      }

      updateEngine(item, animate) {
        const modal = this.querySelector('[data-engine-modal]');
        if (!modal || !item) return;
        this.currentEngine = item;
        const items = [...this.querySelectorAll('[data-engine-rack] [data-engine-id]')];
        const index = items.indexOf(item);
        items.forEach((candidate) => {
          const selected = candidate === item;
          candidate.querySelectorAll('[data-engine-trigger]').forEach((button) => {
            button.setAttribute('aria-pressed', String(selected));
            button.setAttribute('aria-expanded', String(selected));
          });
        });
        modal.querySelectorAll('[data-engine-art]').forEach((art) => { art.hidden = art.dataset.engineArt !== item.dataset.engineId; });
        modal.querySelectorAll('[data-engine-detail]').forEach((detail) => { detail.hidden = detail.dataset.engineDetail !== item.dataset.engineId; });
        const counter = modal.querySelector('[data-engine-counter]');
        if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;
        if (animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const art = modal.querySelector('[data-engine-art]:not([hidden])');
          const detail = modal.querySelector('[data-engine-detail]:not([hidden])');
          art?.animate([{ opacity: 0, transform: 'translateX(16px) scale(.97)' }, { opacity: 1, transform: 'translateX(0) scale(1)' }], { duration: 440, easing: 'cubic-bezier(.22,1,.36,1)' });
          detail?.animate([{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 380, easing: 'ease-out' });
        }
      }

      onKeydown(event) {
        const current = event.target.closest('[role="tab"]');
        if (!current || !this.contains(current)) return;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const index = tabs.indexOf(current);
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(tabs[next].dataset.tab, true, true);
      }

      activate(key, focus, animate = false) {
        const tabs = this.querySelectorAll('[role="tab"]');
        const panels = this.querySelectorAll('[data-panel]');
        let activeTab;
        tabs.forEach((tab) => {
          const selected = tab.dataset.tab === key;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          if (selected) activeTab = tab;
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.panel !== key; });
        if (!activeTab) return;
        inkdeksActiveTabs.set(this.dataset.sectionId, key);
        if (focus) activeTab.focus();
        if (animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const effects = {
            color: 'is-inking',
            dtg: 'is-dtg-printing',
            dtf: 'is-dtf-transferring',
            production: 'is-producing'
          };
          tabs.forEach((tab) => tab.classList.remove(...Object.values(effects)));
          void activeTab.offsetWidth;
          activeTab.classList.add(effects[key]);
          clearTimeout(this.effectTimer);
          this.effectTimer = setTimeout(() => activeTab.classList.remove(effects[key]), 1150);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inkdeks-professional-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inkdeks-hero-slider')) {
    customElements.define('inkdeks-hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-hero-slide]')];
        this.index = 0;
        this.pauses = new Set();
        if (this.slides.length < 2) return;

        this.onClick = (event) => {
          const arrow = event.target.closest('[data-hero-direction]');
          const dot = event.target.closest('[data-hero-dot]');
          if (arrow && this.contains(arrow)) this.show(this.index + Number(arrow.dataset.heroDirection), true);
          else if (dot && this.contains(dot)) this.show(Number(dot.dataset.heroDot), true);
        };
        this.onMouseEnter = () => this.pause('hover');
        this.onMouseLeave = () => this.resume('hover');
        this.onFocusIn = () => this.pause('focus');
        this.onFocusOut = () => setTimeout(() => { if (!this.contains(document.activeElement)) this.resume('focus'); }, 0);
        this.onTouchStart = (event) => {
          if (event.touches.length === 1) this.touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        };
        this.onTouchEnd = (event) => {
          if (!this.touchStart || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - this.touchStart.x;
          const dy = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.25) this.show(this.index + (dx < 0 ? 1 : -1), true);
        };
        this.onVisibilityChange = () => document.hidden ? this.pause('hidden') : this.resume('hidden');
        this.onBlockSelect = (event) => {
          const slide = event.target.closest('[data-hero-slide]');
          if (!slide || !this.contains(slide)) return;
          this.show(this.slides.indexOf(slide), false);
          this.pause('editor');
        };
        this.onBlockDeselect = () => this.resume('editor');

        this.addEventListener('click', this.onClick);
        this.addEventListener('mouseenter', this.onMouseEnter);
        this.addEventListener('mouseleave', this.onMouseLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        this.querySelector('.inkdeks-pro-hero__slides')?.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.querySelector('.inkdeks-pro-hero__slides')?.addEventListener('touchend', this.onTouchEnd, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => entry.isIntersecting ? this.resume('offscreen') : this.pause('offscreen'), { threshold: .2 });
          this.observer.observe(this);
        }
        this.schedule();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        if (!this.onClick) return;
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('mouseenter', this.onMouseEnter);
        this.removeEventListener('mouseleave', this.onMouseLeave);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        this.querySelector('.inkdeks-pro-hero__slides')?.removeEventListener('touchstart', this.onTouchStart);
        this.querySelector('.inkdeks-pro-hero__slides')?.removeEventListener('touchend', this.onTouchEnd);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      show(index, restart) {
        if (!this.slides?.length || !Number.isFinite(index)) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => {
          const active = position === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.querySelectorAll('[data-hero-dot]').forEach((dot, position) => {
          const active = position === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
        if (restart) this.schedule();
      }

      pause(reason) {
        this.pauses.add(reason);
        clearTimeout(this.timer);
      }

      resume(reason) {
        this.pauses.delete(reason);
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        if (this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.pauses.size || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const delay = Math.max(4000, Number(this.dataset.interval) || 6000);
        this.timer = setTimeout(() => { this.show(this.index + 1, false); this.schedule(); }, delay);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inkdeks-spot-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!window.inkdeksShowcasePricingJumpBound) {
    window.inkdeksShowcasePricingJumpBound = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-inkdeks-showcase-pricing]');
      if (!link || new URL(link.href, window.location.href).hash !== '#inkdeks-pricing') return;

      const target = document.getElementById('inkdeks-pricing')
        || document.querySelector('.inkdeks-pricing-cards-section .ipc__header')
        || document.querySelector('.inkdeks-pricing-cards-section');
      if (!target) return;

      event.preventDefault();
      if (!target.id) target.style.scrollMarginTop = window.innerWidth <= 620 ? '80px' : '130px';
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      if (!window.Shopify?.designMode) {
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}#inkdeks-pricing`);
      }
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["professional-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFooter = (root) => {
      root.querySelectorAll('.ink-footer__toggle').forEach((toggle) => {
        if (toggle.dataset.ready) return;
        toggle.dataset.ready = 'true';
        toggle.addEventListener('click', () => {
          if (!window.matchMedia('(max-width: 749px)').matches) return;
          toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') !== 'true');
        });
      });
    };
    document.querySelectorAll('.ink-footer').forEach(initializeFooter);
    document.addEventListener('shopify:section:load', (event) => {
      const footer = event.target.querySelector('.ink-footer');
      if (footer) initializeFooter(footer);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
